// Import Swiper and its modules
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
// DOM Elements
const creditTab = document.getElementById('creditTab');
const installmentTab = document.getElementById('installmentTab');
const rangeInput = document.getElementById('rangeInput');
const rangeValue = document.getElementById('rangeValue');
const rangeForm = document.getElementById('rangeForm');

// Format currency helper
const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

// Navigation handlers
function handlePrevClick(swiper) {
    if (!swiper) {
      console.warn('Swiper is not initialized yet');
      return;
    }
    console.log('Previous button clicked');
    swiper.slidePrev();
    console.log('Current slide:', swiper.activeIndex);
  }

  function handleNextClick(swiper) {
    if (!swiper) {
      console.warn('Swiper is not initialized yet');
      return;
    }
    console.log('Next button clicked');
    swiper.slideNext();
    console.log('Current slide:', swiper.activeIndex);
  }

// Form handlers
const handleTabClick = (tab) => {
  if (tab === 'credit') {
    creditTab.classList.add('active');
    installmentTab.classList.remove('active');
  } else {
    installmentTab.classList.add('active');
    creditTab.classList.remove('active');
  }
};

const handleRangeChange = (event) => {
  rangeValue.textContent = event.target.value;
};

const handleFormSubmit = (event) => {
  event.preventDefault();
  console.log('Form submitted with value:', rangeInput.value);
};

// Initialize Swiper
let swiperInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  console.log('Initializing banner slider');

  // Initialize Swiper
    swiperInstance = new Swiper('.banner__slider', {
        modules: [Autoplay, EffectFade, Navigation], // Use the imported modules directly
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 10000, // Reduced delay for testing
            disableOnInteraction: false,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.banner__nav--prev',
            nextEl: '.banner__nav--next',
        },
        on: {
            init: (sw) => {
                console.log('Swiper initialized successfully');
            },
            slideChange: () => {
                console.log('Slide changed to:', swiperInstance?.activeIndex);
            }
        }
    });



  // Event listeners
  if (swiperInstance) {
    document.querySelector('.banner__nav--prev').addEventListener('click', () => handlePrevClick(swiperInstance));
    document.querySelector('.banner__nav--next').addEventListener('click', () => handleNextClick(swiperInstance));
  }
  creditTab.addEventListener('click', () => handleTabClick('credit'));
  installmentTab.addEventListener('click', () => handleTabClick('installment'));
  rangeInput.addEventListener('input', handleRangeChange);
  rangeForm.addEventListener('submit', handleFormSubmit);
});